import styled from 'styled-components/native'
import { atlTheme } from '../../../atlTheme'

export const CardContainer = styled.View`
  background-color: ${atlTheme.ColorSurface};
  margin-vertical: ${atlTheme.SpacingAtomic}px;
  border-radius: ${atlTheme.BorderRadiusCard}px;
`
